import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const SortAndView = ({ 
  sortBy, 
  onSortChange, 
  viewMode, 
  onViewModeChange, 
  totalProducts,
  comparisonCount,
  onClearComparison,
  onViewComparison 
}) => {
  const sortOptions = [
    { value: 'popularity', label: 'Most Popular' },
    { value: 'price-low', label: 'Price: Low to High' },
    { value: 'price-high', label: 'Price: High to Low' },
    { value: 'rating', label: 'Highest Rated' },
    { value: 'newest', label: 'Newest Arrivals' },
    { value: 'name-az', label: 'Name: A to Z' },
    { value: 'name-za', label: 'Name: Z to A' }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-4">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between space-y-4 lg:space-y-0">
        {/* Left Section - Results Count */}
        <div className="flex items-center space-x-4">
          <div className="text-sm text-muted-foreground">
            <span className="text-foreground font-semibold">{totalProducts}</span> products found
          </div>
          
          {/* Comparison Counter */}
          {comparisonCount > 0 && (
            <div className="flex items-center space-x-2 bg-primary/10 border border-primary/30 rounded-lg px-3 py-1">
              <Icon name="GitCompare" size={16} className="text-primary" />
              <span className="text-sm text-primary font-medium">
                {comparisonCount} selected
              </span>
              <div className="flex items-center space-x-1">
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={onViewComparison}
                  disabled={comparisonCount < 2}
                  className="text-xs h-6 px-2"
                >
                  Compare
                </Button>
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={onClearComparison}
                  className="h-6 w-6"
                >
                  <Icon name="X" size={12} />
                </Button>
              </div>
            </div>
          )}
        </div>

        {/* Right Section - Controls */}
        <div className="flex items-center space-x-4">
          {/* Sort Dropdown */}
          <div className="flex items-center space-x-2">
            <Icon name="ArrowUpDown" size={16} className="text-muted-foreground" />
            <Select
              options={sortOptions}
              value={sortBy}
              onChange={onSortChange}
              placeholder="Sort by"
              className="min-w-[180px]"
            />
          </div>

          {/* View Mode Toggle */}
          <div className="flex items-center bg-muted/30 rounded-lg p-1">
            <Button
              variant={viewMode === 'grid' ? 'default' : 'ghost'}
              size="sm"
              onClick={() => onViewModeChange('grid')}
              className="px-3"
            >
              <Icon name="Grid3X3" size={16} />
            </Button>
            <Button
              variant={viewMode === 'list' ? 'default' : 'ghost'}
              size="sm"
              onClick={() => onViewModeChange('list')}
              className="px-3"
            >
              <Icon name="List" size={16} />
            </Button>
          </div>

          {/* Additional Actions */}
          <div className="flex items-center space-x-2">
            <Button
              variant="outline"
              size="sm"
              iconName="Download"
              iconPosition="left"
              className="hidden md:flex"
            >
              Export
            </Button>
            <Button
              variant="outline"
              size="icon"
              className="relative"
            >
              <Icon name="Share2" size={16} />
            </Button>
          </div>
        </div>
      </div>

      {/* Mobile Sort & Filter Bar */}
      <div className="lg:hidden mt-4 pt-4 border-t border-border">
        <div className="flex items-center justify-between">
          <Button
            variant="outline"
            size="sm"
            iconName="Filter"
            iconPosition="left"
            className="flex-1 mr-2"
          >
            Filters
          </Button>
          <Button
            variant="outline"
            size="sm"
            iconName="ArrowUpDown"
            iconPosition="left"
            className="flex-1 ml-2"
          >
            Sort
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SortAndView;